/* eslint-disable no-param-reassign */
import { Token } from "@pancakeswap/sdk";
import { useCombinedActiveList } from "./useCombinedActiveList";
import { useTokensFromMap } from "./useTokensFromMap";

export function useAllTokens(): { [address: string]: Token } {
  const allTokens = useCombinedActiveList();
  return useTokensFromMap(allTokens, true);
}
